import type { ApiExplorerContext, ApiExplorerResourceServer } from './api-explorer.models';

function serverTokens(server: ApiExplorerResourceServer): string[] {
  return [server.name, server.type, server.resourceType, server.datasetType]
    .map((value) => String(value ?? '').trim().toLowerCase())
    .filter(Boolean);
}

/** True when the dataset's resource server is GATEWAY (API paths need `/dataplane/rsp/...`). */
export function isGatewayApiExplorerContext(
  context: ApiExplorerContext | null | undefined,
): boolean {
  return (context?.resourceServers ?? []).some((server) =>
    serverTokens(server).some((value) => value === 'gateway' || value.includes('gateway')),
  );
}

/** Insert `/rsp` after `/dataplane` unless it is already present. Non-dataplane paths are unchanged. */
export function withRspDataplanePath(path: string): string {
  if (/^\/dataplane\/rsp(\/|$)/i.test(path)) return path;
  const match = path.match(/^\/dataplane\/(.*)$/i);
  if (!match) return path;
  return `/dataplane/rsp/${match[1]}`;
}

export function rewriteOpenApiPathsForGateway<T>(
  paths: Record<string, T> | undefined,
): Record<string, T> | undefined {
  if (!paths) return paths;
  const next: Record<string, T> = {};
  for (const [path, value] of Object.entries(paths)) {
    next[withRspDataplanePath(path)] = value;
  }
  return next;
}
